module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-inleft03.75324ce1.svg";